import { Button} from "@mui/material";
import { useForm } from "react-hook-form";
import RadioGroup from "components/forms/RadioGroup";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { handleSetSelection } from "store/wizard";
import { useEffect } from "react";
import TextInput from "components/forms/TextInput";

const IndividualStep = (props:any) => {
  const { submitCallback, label, step, backCallback, options } = props;
  const { control, handleSubmit, watch, formState: { errors }, setValue } = useForm();
  const dispatch = useAppDispatch();
  const { selection } = useAppSelector((state) => state.wizard);
  const selectedStep = watch("selection");
  useEffect(() => {
    if(selectedStep) {
      const regex = /^(?:[0-9]|[1-9][0-9]|[1-2][0-9]{2}|3[0-5][0-9]|36[0-5])$/;
      if(regex.test(selectedStep)) {
        let selection = parseInt(selectedStep);
        if(step === 1 || step === 2) {
          selection = parseInt(selectedStep) * options[0]["weight"];
        }
        dispatch(handleSetSelection({
          selection: selection,
          step: step
        }));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedStep]);

  useEffect(() => {
    if(selection[0] && step === 0) {
      setValue("selection", selection[0]);
    }
  },[selection, setValue, step]);

  const onSubmit = () => {
    submitCallback(step);
  };
  const onBack = () => {
    backCallback();
  };

  return ( 
    <form onSubmit={handleSubmit(onSubmit)}>
      {
        (step === 1 || step === 2) ? (
          <div className="row">
            <div className="col-lg-8 col-xl-8 col-12">
              <TextInput
                control={control}
                name="selection" 
                defaultValue={selection[step] ? selection[step]/options[0]["weight"] : ""}
                label="Amount"
                errors={errors}
                rules={{
                  required: "This field is required",
                  min: {
                    value: 0,
                    message: "Enter a valid number between 0 and 365",
                  },
                  max: {
                    value: 365,
                    message: "Enter a valid number between 0 and 365",
                  },
                }}
              />
            </div>
          </div>
        ) : (
          <RadioGroup 
            control={control} 
            name="selection" 
            label={label} 
            options={options} 
            defaultValue={selection[step] ? selection[step] : null}
            disabled={step === 7 && !selection[step-1]}
          />
        )
      }
      <div className="d-flex">
        {
          step >= 1 && (
            <Button 
              variant="outlined"
              size="small"
              disableElevation
              className="me-2"
              onClick={() => onBack()}
              >
                Previous
            </Button>
          )
        }
        <Button 
          type="submit"
          variant="contained"
          size="small"
          disableElevation
          >
            {
              step < 7 ? "Next" : "Complete"
            }
        </Button>
      </div>
    </form>
  );
};
export default IndividualStep;
